export default {

    /** 共通エラーメッセージ **/
    allErrors: {},

    /** 共通リスト**/
    listObj: {},
    listObjKeep: {},
    // 0:waiting 1:loading 2:success 3:failed
    listObjLoadStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    listObjSeeMoreLoadStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    listItemDeleteStatus: 0,


    // user
    user: {},
    // 0:waiting 1:loading 2:success 3:failed
    userLoadStatus: 0,

    // 画面リフレッシュ
    refreshArr: {
        // 応募情報一覧(会社)
        cmpApplys: false,
        // 応募状況(会社)
        cmpApplyStatus: false,
        // 契約情報
        contractList: false,
        // 入場予定一覧
        enterPlan: false,
        // 場所(面接・入場)
        placeList: false,
        // 案件各一覧
        cmpActProjs: false,
        // 換金一覧
        exchangeInfo: false,
        // 換金月明細
        exchangeMonth: false,
        // 法人一覧
        companyList: false,
        // スキルシート一覧
        techResume: false,
        // Lev一覧
        techLevel: false,
        // システムメール通知機能
        sysMail: false,
    },

    /** 個人情報取得 **/
    privateInfo: {},
    // 0:waiting 1:loading 2:success 3:failed
    privateInfoLoadStatus: 0,

    /** 郵便住所 **/
   // addressInfo:{},
   // zipcodeErrors: {},
   // // 0:waiting 1:loading 2:success 3:failed
   // addressInfoLoadStatus: 0

    /** カスタマイズシェアURL取得(案件・要員) **/
    custShareUrl:{},
    // 0:waiting 1:loading 2:success 3:failed
    custShareUrlLoadStatus: 0,

    /** uniqueチェック **/
    uniqueCheckErr:{},
    uniqueCheckStatus: 0,

    /** selectGroup送信 **/
    sendMailComStatus: 0,
    sendMailComRes: {},

    /** 応募詳細メッセージ  **/
    addApplyHisMsg: {},
    addApplyHisMsgStatus: 0,

}
